import React from 'react';
import GlobalContextWrapper from 'utilities/GlobalContextWrapper';
import AuthenticatedApp from './components/AuthenticatedApp';
// eslint-disable-next-line import/order
import Routes from 'screens/Routes';
import Background from './components/Background';

export default function App() {
    return (
        <AuthenticatedApp>
            <GlobalContextWrapper>
                <Background>
                    <Routes />
                </Background>
            </GlobalContextWrapper>
        </AuthenticatedApp>
    );
}
